import styled from 'styled-components';
import media from '../../styles/config/mediaQueries';
import { rgba } from 'polished';
import { theme } from '../../styles/config/theme';
import { typeStyle } from '../../styles/config/typeStyles';
import { StyledWrapper } from '../common/Wrapper/Wrapper.styles';

const StyledContainer = styled.section`
  ${media.mobile`
    margin-bottom: 26px;
    padding-top: 19px;
  `}
  ${media.desktop`
    margin-bottom: 10px;
  `}
`;

const StyledPlayerCont = styled.div`
  width: 100%;

  .plyr__video-wrapper {
    perspective: 100;
  }

  .plyr--fullscreen-fallback {
    display: flex;
    justify-content: center;
  }

  .plyr--fullscreen-fallback .plyr__video-wrapper {
    padding: 0;
    margin: 0;
  }

  .plyr__poster {
    background-size: cover;
  }

  ${media.mobile`
    margin-bottom: 16px;
  `}
`;

const StyledArticle = styled.article`
  &:first-of-type {
    padding-top: 0;
  }
  ${media.mobile`
    padding-top: 19px;
  `}
  ${media.desktop`
    margin-bottom: 6px;
    border: 1px solid ${rgba(theme.color.white, 0.2)};
    ${StyledWrapper} {
      padding: 26px 26px 26px 26px;
    }
  `}
`;

const StyledAuthorContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${media.mobile`
    margin-bottom: 9px;
  `}
  ${media.desktop`
    margin-bottom: 16px;
  `}
`;

const StyledAuthorName = styled.h3`
  ${media.mobile`
    ${typeStyle.h5};
  `}
  ${media.desktop`
    ${typeStyle.h3}
  `}
`;

const StyledAuthorInfo = styled.div`
  display: flex;
  align-items: center;

  > span {
    ${media.mobile`
      margin-left: 7px;
      ${typeStyle['font-10']};
    `}
    ${media.desktop`
      margin: 0 11px;
      ${typeStyle['font-14']};
    `}
  }
`;

const StyledBookmarkButton = styled.button`
  width: 18px;
  height: 18px;

  svg {
    width: 100%;
    height: 100%;
  }
`;

const StyledTitle = styled.h2`
  ${media.mobile`
    margin-bottom: 5px;
    ${typeStyle.h2}
  `}
  ${media.desktop`
    margin-bottom: 8px;
    ${typeStyle['font-20-bold']}
  `}
`;

const StyledDescription = styled.p`
  opacity: 0.9;
  ${media.mobile`
    ${typeStyle['font-13']};
  `}
  ${media.desktop`
    ${typeStyle['font-14']}
  `}
`;

const StyledMoreButton = styled.button`
  text-decoration: underline;
  ${media.mobile`
    ${typeStyle['font-13-bold']};
  `}
  ${media.desktop`
    ${typeStyle['font-14-bold']}
  `}
`;

const StyledSpacer = styled.div`
  width: 100%;
  ${media.mobile`
    height: 1px;
    margin-top: 26px;
    background-color: ${rgba(theme.color.white, 0.1)};
  `}
`;

export {
  StyledContainer,
  StyledArticle,
  StyledAuthorContent,
  StyledAuthorName,
  StyledAuthorInfo,
  StyledBookmarkButton,
  StyledTitle,
  StyledDescription,
  StyledMoreButton,
  StyledSpacer,
  StyledPlayerCont,
};
